import * as types from "../types";

const initialState = {
    openModal: false,
    modalMessage: ""
};

export default function modal(
    state = initialState,
    { type, payload }
) {
    switch (type) {
        case types.OPEN_UPDATE_MODAL:
            return {
                ...state,
                openModal: true,
                modalMessage: payload
            };
        case types.CLOSE_UPDATE_MODAL:
            return {
                ...state,
                openModal: false,
                modalMessage: ""
            };


        default:
            return state;
    }
}
